import React, { useEffect, useState } from "react";
import { getBagOfOrder } from "../actions/storeActions";
import Loading from "../helpers/Loading";
import bg from "../assets/bg1.png";
import NoData from "../components/NoData";

const Orders = () => {
  const [order, setOrder] = useState(null);
  useEffect(() => {
    (async function getOrder() {
      const data = await getBagOfOrder();

      setOrder(data);
    })();
  }, []);
  useEffect(() => {
    return () => setOrder(null);
  }, []);
  if (order === null) return <Loading />;
  return (
    <div className="order_container">
      {order.length > 0 ? (
        order
          .slice()
          .reverse()
          .map((data, idx) => {
            const {
              totalPrice,
              serviceRate,
              serviceType,
              orderId,
              orderData,
              status,
              message,
            } = data;

            return (
              <div className="the_order" key={orderId}>
                <p className="the_order_id">Order Id: {orderId}</p>

                <div className="orderStatus_container">
                  <div
                    className={
                      status === "Read" ? "noStatus checked" : "noStatus"
                    }
                  ></div>
                  <div
                    className={
                      status === "Pending" ? "Approve checked" : "Approve"
                    }
                  ></div>
                  <div
                    className={
                      status === "Completed" ? "Complete checked" : "Complete"
                    }
                  ></div>
                </div>
                <div className="order_detail">
                  <div className="order_data">
                    {orderData.map((order) => {
                      const { name, total, _id, price, thumbnail } = order;
                      return (
                        <div key={_id}>
                          <div className="order">
                            <div className="cart_thumbnail">
                              <img
                                src={
                                  thumbnail
                                    ? `https://drive.google.com/thumbnail?id=${thumbnail}`
                                    : bg
                                }
                                alt=""
                              />
                            </div>
                            <div className="order_details">
                              <p>
                                {name} x {total}
                              </p>
                              <p>₱{price * total}</p>
                              {/* <div className="quantity">
                          
                        </div> */}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="order_detail_message">
                    <div className="order_total_price">
                      <p className="detail_header">Total</p>
                      <div className="detail">
                        <p>₱{totalPrice}</p>
                      </div>
                    </div>
                    <p className="detail_header">Order Summary</p>
                    <div className="detail">
                      <p>{`Order price is ${totalPrice} pesos + service fee of ${serviceRate} pesos =  ${
                        totalPrice + serviceRate
                      }`}</p>
                      <p>{`Type of Payment = ${serviceType}`}</p>
                      <p>{message}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
      ) : (
        <NoData title=" Bag is empty!" />
      )}
    </div>
  );
};

export default Orders;
